/* Holasticker · editor de llaveros
   ---------------------------------------------------------------------------
   Misma base que hs-editor.js (pegatinas), con dos diferencias:
   - El diseno se coloca sobre la pieza de madera, dentro de la zona de
     impresion, igual que la linea rosa de las fotos de producto.
   - Puede haber dos caras. Cada una lleva su archivo, su encuadre y su
     vista previa, y no se puede comprar hasta tener las que tocan.

   Reglas de la casa, las mismas que en pegatinas:
   - Todo va dentro de try/catch: si algo falla, comprar debe seguir igual.
   - El lienzo que ve el cliente y el que se exporta salen de la misma
     funcion de dibujo.
*/
(function () {
  'use strict';

  if (window.HSLlavero) return;

  var EXPORT_MAX = 1000;
  var ZOOM_MIN = 0.2, ZOOM_MAX = 6;
  var ROSA = '#ff4d94';

  /* Nombres de los campos que viajan con el pedido. Con guion bajo delante
     el cliente no los ve en el carrito, pero salen en el pedido. */
  var CAMPOS = {
    A: { archivo: 'properties[Diseño]',         previa: 'properties[_vista_previa]',         nombre: 'Cara delantera' },
    B: { archivo: 'properties[Diseño trasero]', previa: 'properties[_vista_previa_trasera]', nombre: 'Cara trasera' }
  };
  var PROP_ENCUADRE = 'properties[_encuadre]';

  /* --- Formas -------------------------------------------------------------
     ratio = ancho / alto de la pieza. margen = hueco entre el borde de la
     madera y la zona de impresion, medido en las fotos de producto.
     PROVISIONAL hasta tener las medidas exactas de cada llavero. */

  var FORMAS = {
    cuadrado:    { ratio: 1,    margen: 0.10, cuerpo: redondeado(0.10) },
    redondo:     { ratio: 1,    margen: 0.09, cuerpo: circulo },
    rectangular: { ratio: 0.65, margen: 0.10, cuerpo: redondeado(0.09) }
  };

  function circulo(ctx, x, y, w, h) {
    ctx.beginPath();
    ctx.arc(x + w / 2, y + h / 2, Math.min(w, h) / 2, 0, Math.PI * 2);
    ctx.closePath();
  }

  function redondeado(factor) {
    return function (ctx, x, y, w, h) {
      var r = Math.min(w, h) * factor;
      ctx.beginPath();
      ctx.moveTo(x + r, y);
      ctx.lineTo(x + w - r, y);
      ctx.quadraticCurveTo(x + w, y, x + w, y + r);
      ctx.lineTo(x + w, y + h - r);
      ctx.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
      ctx.lineTo(x + r, y + h);
      ctx.quadraticCurveTo(x, y + h, x, y + h - r);
      ctx.lineTo(x, y + r);
      ctx.quadraticCurveTo(x, y, x + r, y);
      ctx.closePath();
    };
  }

  /* --- Utilidades --------------------------------------------------------- */

  function el(tag, clase, texto) {
    var n = document.createElement(tag);
    if (clase) n.className = clase;
    if (texto != null) n.textContent = texto;
    return n;
  }

  function boton(txt, clase) {
    var b = el('button', clase, txt);
    b.type = 'button';
    return b;
  }

  function limitar(v, min, max) { return v < min ? min : (v > max ? max : v); }

  function radio(grupo) {
    return document.querySelector('[data-hs-group="' + grupo + '"]:checked');
  }

  function formaActual() {
    var r = radio('shape');
    var k = r ? r.value : 'cuadrado';
    return FORMAS[k] ? k : 'cuadrado';
  }

  function etiqueta(grupo, porDefecto) {
    var r = radio(grupo);
    return r ? r.dataset.hsLabel : porDefecto;
  }

  function dosCaras() {
    var r = radio('caras');
    return !!r && r.value === 'dos';
  }

  function formularioCompra() {
    return document.querySelector('form[action*="/cart/add"]');
  }

  function ponerArchivo(nombre, file) {
    var f = formularioCompra();
    if (!f) return false;
    var input = f.querySelector('input[type="file"][name="' + nombre + '"][data-hs-generado]');
    if (!file) { if (input) input.remove(); return true; }
    if (!input) {
      input = document.createElement('input');
      input.type = 'file';
      input.name = nombre;
      input.hidden = true;
      input.setAttribute('data-hs-generado', '');
      f.appendChild(input);
    }
    try {
      var dt = new DataTransfer();
      dt.items.add(file);
      input.files = dt.files;
    } catch (e) { return false; }
    f.setAttribute('enctype', 'multipart/form-data');
    return true;
  }

  function ponerTexto(nombre, valor) {
    var f = formularioCompra();
    if (!f) return;
    var input = f.querySelector('input[type="hidden"][name="' + nombre + '"]');
    if (valor == null || valor === '') { if (input) input.remove(); return; }
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = nombre;
      f.appendChild(input);
    }
    input.value = valor;
  }

  /* --- Madera --------------------------------------------------------------
     Textura sacada de la foto del llavero en blanco. Si no carga, se usa un
     tono haya liso: la vista previa sigue sirviendo. */

  var madera = null;
  (function () {
    var src = window.HSLlaveroMadera;
    if (!src) return;
    var i = new Image();
    i.onload = function () { madera = i; repintar(); };
    i.src = src;
  })();

  function rellenoMadera(ctx) {
    if (madera) {
      try { return ctx.createPattern(madera, 'repeat'); } catch (e) {}
    }
    return '#ecd2ae';
  }

  /* --- Estado --------------------------------------------------------------
     Una ficha por cara. estado: ninguno | pendiente | sin-previa | listo */

  function caraVacia() {
    return { img: null, nombre: '', t: { escala: 1, x: 0, y: 0, giro: 0 }, guardado: false, estado: 'ninguno' };
  }

  var caras = { A: caraVacia(), B: caraVacia() };
  var activa = 'A';
  var combinacionOk = true;
  var inputs = { A: null, B: null };

  var modal = null, lienzo = null, ctx = null, zoomInput = null, aviso = null, subtitulo = null;
  var pestanas = null, vacio = null, bGuardar = null;

  function inputDe(cara) {
    if (!inputs[cara]) {
      inputs[cara] = document.querySelector('input[type="file"][data-hs-input="' + cara + '"]');
    }
    return inputs[cara];
  }

  /* --- Dibujo --------------------------------------------------------------
     Pieza de madera ocupando todo el lienzo; el diseno se recorta a la zona
     de impresion. */

  function zona(F, w, h) {
    var m = Math.min(w, h) * F.margen;
    return { x: m, y: m, w: w - 2 * m, h: h - 2 * m };
  }

  function dibujar(c, w, h, forma, cara, conGuia) {
    var F = FORMAS[forma] || FORMAS.cuadrado;
    var z = zona(F, w, h);
    var d = caras[cara];

    c.clearRect(0, 0, w, h);

    c.save();
    F.cuerpo(c, 0, 0, w, h);
    c.fillStyle = rellenoMadera(c);
    c.fill();
    c.restore();

    if (d.img) {
      c.save();
      F.cuerpo(c, z.x, z.y, z.w, z.h);
      c.clip();
      var base = Math.max(z.w / d.img.naturalWidth, z.h / d.img.naturalHeight);
      var e = base * d.t.escala;
      c.translate(z.x + z.w / 2 + d.t.x * z.w, z.y + z.h / 2 + d.t.y * z.h);
      c.rotate(d.t.giro * Math.PI / 180);
      c.imageSmoothingQuality = 'high';
      c.drawImage(d.img,
        -d.img.naturalWidth * e / 2, -d.img.naturalHeight * e / 2,
        d.img.naturalWidth * e, d.img.naturalHeight * e);
      c.restore();
    }

    if (conGuia) {
      c.save();
      F.cuerpo(c, z.x, z.y, z.w, z.h);
      c.strokeStyle = ROSA;
      c.lineWidth = Math.max(1.5, w * 0.005);
      c.setLineDash([w * 0.03, w * 0.02]);
      c.stroke();
      c.restore();

      c.save();
      F.cuerpo(c, 0, 0, w, h);
      c.strokeStyle = 'rgba(120, 80, 30, 0.35)';
      c.lineWidth = Math.max(1, w * 0.004);
      c.stroke();
      c.restore();
    }
  }

  function repintar() {
    if (!lienzo || !ctx) return;
    dibujar(ctx, lienzo.width, lienzo.height, formaActual(), activa, true);
  }

  function medirLienzo() {
    if (!lienzo) return;
    var F = FORMAS[formaActual()] || FORMAS.cuadrado;
    var caja = lienzo.parentElement;
    var pad = 20;
    var dispW = Math.max(160, caja.clientWidth - pad);
    var dispH = Math.max(160, Math.round(window.innerHeight * 0.42));
    var w = dispW, h = w / F.ratio;
    if (h > dispH) { h = dispH; w = h * F.ratio; }

    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    lienzo.style.width = Math.round(w) + 'px';
    lienzo.style.height = Math.round(h) + 'px';
    lienzo.width = Math.round(w * dpr);
    lienzo.height = Math.round(h * dpr);
    repintar();
  }

  /* --- Gestos: arrastrar, pellizcar y rueda --------------------------------- */

  function conectarGestos() {
    var arrastrando = false, px = 0, py = 0;
    var punteros = {}, distIni = 0, escalaIni = 1;

    function t() { return caras[activa].t; }

    lienzo.addEventListener('pointerdown', function (e) {
      if (!caras[activa].img) return;
      lienzo.setPointerCapture(e.pointerId);
      punteros[e.pointerId] = { x: e.clientX, y: e.clientY };
      var ids = Object.keys(punteros);
      if (ids.length === 1) {
        arrastrando = true; px = e.clientX; py = e.clientY;
      } else if (ids.length === 2) {
        arrastrando = false;
        distIni = separacion(punteros, ids);
        escalaIni = t().escala;
      }
    });

    lienzo.addEventListener('pointermove', function (e) {
      if (!punteros[e.pointerId]) return;
      punteros[e.pointerId] = { x: e.clientX, y: e.clientY };
      var ids = Object.keys(punteros);

      if (ids.length >= 2 && distIni > 0) {
        t().escala = limitar(escalaIni * (separacion(punteros, ids) / distIni), ZOOM_MIN, ZOOM_MAX);
        if (zoomInput) zoomInput.value = String(t().escala);
        repintar();
        return;
      }
      if (!arrastrando) return;
      var r = lienzo.getBoundingClientRect();
      /* El desplazamiento se mide sobre la zona de impresion, no la pieza. */
      var m = Math.min(r.width, r.height) * FORMAS[formaActual()].margen;
      t().x += (e.clientX - px) / Math.max(1, r.width - 2 * m);
      t().y += (e.clientY - py) / Math.max(1, r.height - 2 * m);
      px = e.clientX; py = e.clientY;
      repintar();
    });

    function soltar(e) {
      delete punteros[e.pointerId];
      if (Object.keys(punteros).length < 2) distIni = 0;
      if (Object.keys(punteros).length === 0) arrastrando = false;
    }
    lienzo.addEventListener('pointerup', soltar);
    lienzo.addEventListener('pointercancel', soltar);

    lienzo.addEventListener('wheel', function (e) {
      if (!caras[activa].img) return;
      e.preventDefault();
      t().escala = limitar(t().escala * (e.deltaY < 0 ? 1.08 : 0.925), ZOOM_MIN, ZOOM_MAX);
      if (zoomInput) zoomInput.value = String(t().escala);
      repintar();
    }, { passive: false });
  }

  function separacion(p, ids) {
    var a = p[ids[0]], b = p[ids[1]];
    return Math.hypot(a.x - b.x, a.y - b.y);
  }

  /* --- Modal -------------------------------------------------------------- */

  function construir() {
    modal = el('div', 'hs-ed hs-ed--llavero');
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'Ajusta tu diseño');
    modal.hidden = true;

    var fondo = el('div', 'hs-ed__fondo');
    var panel = el('div', 'hs-ed__panel');

    var cab = el('div', 'hs-ed__cab');
    var tit = el('div', 'hs-ed__tit');
    tit.appendChild(el('h2', 'hs-ed__h', 'Ajusta tu diseño'));
    subtitulo = el('p', 'hs-ed__sub', '');
    tit.appendChild(subtitulo);
    var cerrar = el('button', 'hs-ed__x', '×');
    cerrar.type = 'button';
    cerrar.setAttribute('aria-label', 'Cerrar');
    cab.appendChild(tit);
    cab.appendChild(cerrar);

    /* Pestanas de cara: solo se ven con "Dos caras". */
    pestanas = el('div', 'hs-ed__caras');
    pestanas.setAttribute('role', 'tablist');
    ['A', 'B'].forEach(function (k) {
      var b = boton(CAMPOS[k].nombre, 'hs-ed__cara');
      b.setAttribute('role', 'tab');
      b.setAttribute('data-hs-cara', k);
      b.appendChild(el('span', 'hs-ed__caraok', '✓'));
      b.addEventListener('click', function () { cambiarCara(k); });
      pestanas.appendChild(b);
    });

    var escena = el('div', 'hs-ed__escena');
    lienzo = document.createElement('canvas');
    lienzo.className = 'hs-ed__lienzo';
    ctx = lienzo.getContext('2d');
    escena.appendChild(lienzo);

    /* Encima del lienzo cuando la cara no tiene diseno todavia. */
    vacio = el('div', 'hs-ed__vacio');
    vacio.hidden = true;
    vacio.appendChild(el('p', 'hs-ed__vaciotxt', 'Sube el diseño para la cara trasera. Puede ser distinto del delantero: un nombre, una fecha, tu web…'));
    var bSubirB = boton('Subir diseño trasero', 'hs-ed__b hs-ed__b--fuerte');
    bSubirB.addEventListener('click', function () { var i = inputDe(activa); if (i) i.click(); });
    vacio.appendChild(bSubirB);
    escena.appendChild(vacio);

    aviso = el('p', 'hs-ed__aviso', 'La línea rosa marca la zona de impresión. Lo que quede fuera no se imprime.');

    var mandos = el('div', 'hs-ed__mandos');
    var filaZoom = el('label', 'hs-ed__zoom');
    filaZoom.appendChild(el('span', 'hs-ed__zoomtxt', 'Zoom'));
    zoomInput = document.createElement('input');
    zoomInput.type = 'range';
    zoomInput.min = String(ZOOM_MIN);
    zoomInput.max = String(ZOOM_MAX);
    zoomInput.step = '0.01';
    zoomInput.value = '1';
    zoomInput.className = 'hs-ed__rango';
    filaZoom.appendChild(zoomInput);
    mandos.appendChild(filaZoom);

    var botones = el('div', 'hs-ed__acciones');
    var bGirar = boton('Girar 90°', 'hs-ed__b');
    var bCentrar = boton('Centrar', 'hs-ed__b');
    var bOtro = boton('Cambiar imagen', 'hs-ed__b');
    botones.appendChild(bGirar);
    botones.appendChild(bCentrar);
    botones.appendChild(bOtro);
    mandos.appendChild(botones);

    var pie = el('div', 'hs-ed__pie');
    var bCancelar = boton('Cancelar', 'hs-ed__b hs-ed__b--plano');
    bGuardar = boton('Guardar vista previa', 'hs-ed__b hs-ed__b--fuerte');
    pie.appendChild(bCancelar);
    pie.appendChild(bGuardar);

    panel.appendChild(cab);
    panel.appendChild(pestanas);
    panel.appendChild(escena);
    panel.appendChild(aviso);
    panel.appendChild(mandos);
    panel.appendChild(pie);
    modal.appendChild(fondo);
    modal.appendChild(panel);
    document.body.appendChild(modal);

    fondo.addEventListener('click', cerrarModal);
    cerrar.addEventListener('click', cerrarModal);
    bCancelar.addEventListener('click', cerrarModal);
    bGuardar.addEventListener('click', guardar);
    bGirar.addEventListener('click', function () {
      var t = caras[activa].t; t.giro = (t.giro + 90) % 360; repintar();
    });
    bCentrar.addEventListener('click', function () {
      caras[activa].t = { escala: 1, x: 0, y: 0, giro: 0 };
      if (zoomInput) zoomInput.value = '1';
      repintar();
    });
    bOtro.addEventListener('click', function () { var i = inputDe(activa); if (i) i.click(); });
    zoomInput.addEventListener('input', function () {
      caras[activa].t.escala = parseFloat(zoomInput.value) || 1;
      repintar();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal && !modal.hidden) cerrarModal();
    });
    window.addEventListener('resize', function () { if (modal && !modal.hidden) medirLienzo(); });

    conectarGestos();
  }

  function pintarModal() {
    if (!modal) return;
    var dos = dosCaras();
    if (!dos && activa === 'B') activa = 'A';

    subtitulo.textContent = etiqueta('shape', 'Cuadrado') + ' · ' + etiqueta('pack', '')
      + (dos ? ' · ' + CAMPOS[activa].nombre : '');

    pestanas.hidden = !dos;
    pestanas.querySelectorAll('[data-hs-cara]').forEach(function (b) {
      var k = b.getAttribute('data-hs-cara');
      var on = k === activa;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
      b.classList.toggle('is-hecha', caras[k].guardado || caras[k].estado === 'sin-previa');
    });

    var hay = !!caras[activa].img;
    vacio.hidden = hay;
    ['.hs-ed__mandos', '.hs-ed__pie'].forEach(function (s) {
      var n = modal.querySelector(s);
      if (n) n.style.display = hay ? '' : 'none';
    });
    if (zoomInput) zoomInput.value = String(caras[activa].t.escala);

    var otra = activa === 'A' ? 'B' : 'A';
    var falta = dos && !(caras[otra].guardado || caras[otra].estado === 'sin-previa');
    bGuardar.textContent = falta && activa === 'A' ? 'Guardar y seguir con la trasera' : 'Guardar vista previa';
  }

  function abrirModal() {
    if (!modal) construir();
    modal.hidden = false;
    document.body.classList.add('hs-ed-abierto');
    pintarModal();
    requestAnimationFrame(medirLienzo);
  }

  function cerrarModal() {
    if (!modal) return;
    modal.hidden = true;
    document.body.classList.remove('hs-ed-abierto');
  }

  function cambiarCara(k) {
    activa = k;
    pintarModal();
    medirLienzo();
  }

  /* --- Carga de imagen ---------------------------------------------------- */

  function cargar(file) {
    return new Promise(function (resolve, reject) {
      if (!file || !/^image\//.test(file.type)) return reject(new Error('no-imagen'));
      var url = URL.createObjectURL(file);
      var i = new Image();
      i.onload = function () {
        if (!i.naturalWidth) { URL.revokeObjectURL(url); return reject(new Error('sin-tamano')); }
        resolve(i);
      };
      i.onerror = function () { URL.revokeObjectURL(url); reject(new Error('carga')); };
      i.src = url;
    });
  }

  /* --- Guardar ------------------------------------------------------------ */

  function exportar(cara) {
    var F = FORMAS[formaActual()] || FORMAS.cuadrado;
    var w = EXPORT_MAX, h = Math.round(EXPORT_MAX / F.ratio);
    if (F.ratio < 1) { h = EXPORT_MAX; w = Math.round(EXPORT_MAX * F.ratio); }
    var c = document.createElement('canvas');
    c.width = w; c.height = h;
    /* Sin la linea rosa: es solo una guia, no se imprime. */
    dibujar(c.getContext('2d'), w, h, formaActual(), cara, false);
    return new Promise(function (resolve) { c.toBlob(resolve, 'image/png'); });
  }

  function escribirEncuadre() {
    var datos = { forma: formaActual(), caras: dosCaras() ? 2 : 1 };
    ['A', 'B'].forEach(function (k) {
      if (k === 'B' && !dosCaras()) return;
      var d = caras[k];
      if (!d.img) return;
      datos[k === 'A' ? 'delantera' : 'trasera'] = {
        escala: Math.round(d.t.escala * 1000) / 1000,
        x: Math.round(d.t.x * 1000) / 1000,
        y: Math.round(d.t.y * 1000) / 1000,
        giro: d.t.giro,
        origen: d.nombre
      };
    });
    ponerTexto(PROP_ENCUADRE, JSON.stringify(datos));
  }

  function guardarCara(cara) {
    return exportar(cara).then(function (blob) {
      if (!blob) return false;
      var nombre = cara === 'A' ? 'vista-previa-delantera.png' : 'vista-previa-trasera.png';
      var ok = ponerArchivo(CAMPOS[cara].previa, new File([blob], nombre, { type: 'image/png' }));
      if (ok) {
        caras[cara].guardado = true;
        caras[cara].estado = 'listo';
        escribirEncuadre();
        pintarMiniatura(cara, blob);
      }
      return ok;
    });
  }

  function guardar() {
    var cara = activa;
    if (!caras[cara].img) { cerrarModal(); return; }
    guardarCara(cara).then(function (ok) {
      refrescarCandado();
      var otra = cara === 'A' ? 'B' : 'A';
      var falta = dosCaras() && !(caras[otra].guardado || caras[otra].estado === 'sin-previa');
      if (ok && falta) { cambiarCara(otra); return; }
      cerrarModal();
    }).catch(function () { cerrarModal(); });
  }

  /* Si cambia la forma, las vistas previas guardadas se rehacen solas. */
  function regenerar() {
    ['A', 'B'].forEach(function (k) {
      if (caras[k].img && caras[k].guardado) guardarCara(k).catch(function () {});
    });
  }

  function pintarMiniatura(cara, blob) {
    var fila = document.querySelector('[data-hs-fila="' + cara + '"]');
    if (!fila) return;
    var thumb = fila.querySelector('[data-hs-thumb]');
    if (thumb) {
      if (thumb.dataset.hsBlob) URL.revokeObjectURL(thumb.dataset.hsBlob);
      var u = URL.createObjectURL(blob);
      thumb.dataset.hsBlob = u;
      thumb.src = u;
      thumb.hidden = false;
    }
    fila.hidden = false;
  }

  function limpiar(cara) {
    caras[cara] = caraVacia();
    ponerArchivo(CAMPOS[cara].previa, null);
    escribirEncuadre();
    refrescarCandado();
    if (modal && !modal.hidden) { pintarModal(); repintar(); }
  }

  /* --- Una cara / dos caras ------------------------------------------------
     Con una sola cara lo de la trasera no se envia: se desactiva en vez de
     borrarlo, por si el cliente vuelve a cambiar de idea. */

  function aplicarCaras() {
    var dos = dosCaras();
    var f = formularioCompra();
    if (f) {
      f.querySelectorAll('input[name="' + CAMPOS.B.archivo + '"], input[name="' + CAMPOS.B.previa + '"]')
        .forEach(function (i) { i.disabled = !dos; });
    }
    var filaB = document.querySelector('[data-hs-bloque-b]');
    if (filaB) filaB.hidden = !dos;
    escribirEncuadre();
    refrescarCandado();
    if (modal && !modal.hidden) { pintarModal(); medirLienzo(); }
  }

  /* --- Candado de compra ---------------------------------------------------- */

  function caraLista(k) {
    var e = caras[k].estado;
    return e === 'listo' || e === 'sin-previa';
  }

  function puedeComprar() {
    return combinacionOk && caraLista('A') && (!dosCaras() || caraLista('B'));
  }

  function cajaBotones() {
    return document.querySelector('.product-form-buttons');
  }

  function avisoCandado() {
    var caja = cajaBotones();
    if (!caja) return null;
    var n = caja.querySelector('[data-hs-candado]');
    if (!n) {
      n = el('div', 'hs-candado');
      n.setAttribute('data-hs-candado', '');
      var txt = el('span', 'hs-candado__txt', '');
      txt.setAttribute('data-hs-candado-txt', '');
      var b = el('button', 'hs-candado__b', '');
      b.type = 'button';
      b.setAttribute('data-hs-candado-b', '');
      b.addEventListener('click', function () {
        API.abrir(caraLista('A') ? 'B' : 'A');
      });
      n.appendChild(txt);
      n.appendChild(b);
      caja.insertBefore(n, caja.firstChild);
    }
    return n;
  }

  function aplicarCandado() {
    var bloqueado = !puedeComprar();

    var add = document.querySelector('button[name="add"]');
    if (add) {
      if (bloqueado) {
        if (!add.dataset.hsLock) add.dataset.hsLock = add.disabled ? 'suyo' : 'nuestro';
        if (!add.disabled) add.disabled = true;
        add.setAttribute('aria-disabled', 'true');
      } else if (add.dataset.hsLock) {
        if (add.dataset.hsLock === 'nuestro') {
          add.disabled = false;
          add.removeAttribute('aria-disabled');
        }
        delete add.dataset.hsLock;
      }
    }

    var express = document.querySelector('.accelerated-checkout-block');
    if (express && express.classList.contains('hs-bloqueado') !== bloqueado) {
      express.classList.toggle('hs-bloqueado', bloqueado);
    }

    var n = avisoCandado();
    if (!n) return;
    if (n.hidden === bloqueado) n.hidden = !bloqueado;
    if (!bloqueado) return;

    var txt = n.querySelector('[data-hs-candado-txt]');
    var b = n.querySelector('[data-hs-candado-b]');
    var mensaje, texto;
    if (!combinacionOk) {
      mensaje = 'Esa combinación no está disponible ahora mismo. Cambia la forma, el pack o las caras.';
      texto = '';
    } else if (!caraLista('A')) {
      mensaje = caras.A.estado === 'ninguno'
        ? 'Sube tu diseño para poder añadirlo al carrito.'
        : 'Te falta ajustar tu diseño dentro del llavero.';
      texto = caras.A.estado === 'ninguno' ? 'Subir mi diseño' : 'Ajustar ahora';
    } else {
      mensaje = caras.B.estado === 'ninguno'
        ? 'Has elegido dos caras: falta el diseño de la cara trasera.'
        : 'Te falta ajustar el diseño de la cara trasera.';
      texto = caras.B.estado === 'ninguno' ? 'Subir cara trasera' : 'Ajustar trasera';
    }
    if (txt && txt.textContent !== mensaje) txt.textContent = mensaje;
    if (b) {
      if (b.textContent !== texto) b.textContent = texto;
      if (b.hidden === !!texto) b.hidden = !texto;
    }
  }

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.action || f.action.indexOf('/cart/add') === -1) return;
    if (puedeComprar()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    aplicarCandado();
    var n = document.querySelector('[data-hs-candado]');
    if (n && n.scrollIntoView) n.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }, true);

  document.addEventListener('click', function (e) {
    if (puedeComprar()) return;
    var t = e.target.closest && e.target.closest('.accelerated-checkout-block, button[name="add"]');
    if (!t) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    aplicarCandado();
  }, true);

  var candadoPend = null, moCandado = null;

  function vigilarCandado() {
    var caja = cajaBotones();
    if (!caja) return;
    if (!moCandado) {
      moCandado = new MutationObserver(function () {
        clearTimeout(candadoPend);
        candadoPend = setTimeout(refrescarCandado, 80);
      });
    }
    moCandado.observe(caja, { childList: true, subtree: true });
  }

  function refrescarCandado() {
    if (moCandado) moCandado.disconnect();
    try { aplicarCandado(); } finally { vigilarCandado(); }
  }

  function arrancarCandado() {
    if (!cajaBotones()) return false;
    refrescarCandado();
    return true;
  }

  if (!arrancarCandado()) {
    var intentos = 0;
    var tmr = setInterval(function () {
      if (arrancarCandado() || ++intentos > 40) clearInterval(tmr);
    }, 250);
  }

  /* --- Anadir al carrito ---------------------------------------------------
     Igual que en pegatinas: lo enviamos nosotros, se espera la respuesta y
     se va al carrito. Si falla, se explica y el diseno sigue puesto. */

  var enviando = false;

  function avisoDeError(texto) {
    var f = formularioCompra();
    if (!f) return;
    var n = f.querySelector('[data-hs-error-carrito]');
    if (!n) {
      n = el('p', 'hs-errorcarrito');
      n.setAttribute('data-hs-error-carrito', '');
      var caja = cajaBotones();
      if (caja) caja.insertBefore(n, caja.firstChild);
      else f.appendChild(n);
    }
    n.textContent = texto;
    n.hidden = !texto;
    if (texto && n.scrollIntoView) n.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }

  function avisoDeEspera(texto) {
    var caja = cajaBotones();
    if (!caja) return;
    var n = caja.querySelector('[data-hs-espera]');
    if (!n) {
      n = el('p', 'hs-espera');
      n.setAttribute('data-hs-espera', '');
      n.setAttribute('role', 'status');
      caja.insertBefore(n, caja.firstChild);
    }
    n.textContent = texto;
    n.hidden = !texto;
  }

  function anadirAlCarrito() {
    var f = formularioCompra();
    if (!f || enviando) return;
    enviando = true;
    avisoDeError('');

    var botones = [].slice.call(document.querySelectorAll('button[name="add"]'));
    botones.forEach(function (b) { b.disabled = true; b.setAttribute('aria-busy', 'true'); });
    avisoDeEspera(dosCaras() ? 'Subiendo tus diseños…' : 'Subiendo tu diseño…');

    var datos = new FormData(f);
    datos.delete('sections');

    fetch('/cart/add.js', {
      method: 'POST',
      body: datos,
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) {
        return r.json().then(function (d) { return { ok: r.ok, status: r.status, d: d }; });
      })
      .then(function (res) {
        if (res.ok && !res.d.status) {
          window.location.href = '/cart';
          return;
        }
        var crudo = (res.d && (res.d.description || res.d.message)) || ('HTTP ' + res.status);
        if (window.console) console.warn('[holasticker] carrito rechazado:', crudo, res.d);
        var msg = 'No hemos podido añadir tu pedido al carrito. '
                + 'Comprueba las opciones y vuelve a intentarlo. '
                + 'Tu diseño sigue guardado.';
        if (/too large|demasiado grande|size/i.test(crudo)) {
          msg = 'El archivo pesa demasiado para enviarlo. Prueba con una imagen más ligera.';
        }
        throw new Error(msg);
      })
      .catch(function (e) {
        enviando = false;
        botones.forEach(function (b) { b.disabled = false; b.removeAttribute('aria-busy'); });
        avisoDeEspera('');
        refrescarCandado();
        avisoDeError(String(e.message || e));
      });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('button[name="add"]');
    if (!b) return;
    if (!puedeComprar()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    anadirAlCarrito();
  }, true);

  /* --- API ------------------------------------------------------------------ */

  var API = {
    /* Abre el editor en una cara. Si esa cara no tiene archivo, se pide. */
    abrir: function (cara) {
      try {
        cara = cara === 'B' && dosCaras() ? 'B' : 'A';
        activa = cara;
        if (caras[cara].img) { abrirModal(); return; }
        if (cara === 'B' && caraLista('A')) { abrirModal(); return; }
        var i = inputDe(cara);
        var f = i && i.files && i.files[0];
        if (!f) { if (i) i.click(); return; }
        API.usar(cara, f);
      } catch (e) { if (window.console) console.warn('[holasticker] editor:', e); }
    },

    /* Recibe el archivo elegido para una cara. */
    usar: function (cara, file) {
      try {
        var d = caras[cara];
        d.nombre = file ? file.name : '';
        cargar(file).then(function (i) {
          d.img = i;
          d.guardado = false;
          d.estado = 'pendiente';
          d.t = { escala: 1, x: 0, y: 0, giro: 0 };
          ponerArchivo(CAMPOS[cara].previa, null);
          refrescarCandado();
          activa = cara;
          abrirModal();
        }).catch(function () {
          /* PDF o SVG ilegible: el archivo viaja igual, sin vista previa. */
          caras[cara] = caraVacia();
          caras[cara].nombre = d.nombre;
          caras[cara].estado = 'sin-previa';
          ponerArchivo(CAMPOS[cara].previa, null);
          refrescarCandado();
          var err = document.querySelector('[data-hs-fila="' + cara + '"] ~ [data-hs-error]')
                 || document.querySelector('[data-hs-uploader] [data-hs-error]');
          if (err) {
            err.textContent = 'Ese archivo se envía igual, pero no podemos mostrarte la vista previa. Si quieres verla, sube un PNG o un JPG.';
            err.hidden = false;
          }
          if (modal && !modal.hidden) pintarModal();
        });
      } catch (e) { if (window.console) console.warn('[holasticker] editor:', e); }
    },

    combinacion: function (hay) {
      if (combinacionOk === !!hay) return;
      combinacionOk = !!hay;
      refrescarCandado();
    },
    limpiar: limpiar,
    caras: aplicarCaras
  };

  /* Cambios de forma y de caras desde los selectores. */
  document.addEventListener('change', function (e) {
    var r = e.target.closest && e.target.closest('[data-hs-group]');
    if (!r) return;
    if (r.dataset.hsGroup === 'shape') {
      if (modal && !modal.hidden) { pintarModal(); medirLienzo(); }
      regenerar();
    } else if (r.dataset.hsGroup === 'caras') {
      aplicarCaras();
    } else if (r.dataset.hsGroup === 'pack' && modal && !modal.hidden) {
      pintarModal();
    }
  });

  window.HSLlavero = API;
})();
